import "./CourseCard.scss";
import { Link } from "react-router-dom";
import { Class } from "../../types";
import bioImg from "../../assets/course-cards/biology.jpg";
import mathsImg from "../../assets/course-cards/maths.jpg";
import chemistryImg from "../../assets/course-cards/chemistry.jpg";
import physicsImg from "../../assets/course-cards/physics.jpg";
import msraImg from "../../assets/course-cards/msra.jpg";
import dukeElderImg from "../../assets/course-cards/duke-elder.jpg";
import part1Img from "../../assets/course-cards/frcophth-part-1.jpg";
import part2Img from "../../assets/course-cards/frcophth-part-2.jpg";
import ProgressBar from "@ramonak/react-progress-bar";

// `_class` used because `class` is a protected word
const CourseCard = (_class: Class) => {
  let bgImage;
  switch (_class.subjectName) {
    case "Maths":
    case "Mathematics":
      bgImage = mathsImg;
      break;
    case "Biology":
      bgImage = bioImg;
      break;
    case "Chemistry":
      bgImage = chemistryImg;
      break;
    case "Physics":
      bgImage = physicsImg;
      break;
    case "MSRA":
      bgImage = msraImg;
      break;
    case "Duke Elder":
      bgImage = dukeElderImg;
      break;
    case "FRCOphth Part 1":
      bgImage = part1Img;
      break;
    case "FRCOphth Part 2 (Written)":
      bgImage = part2Img;
      break;
    default:
      bgImage = undefined;
      break;
  }

  const completedPercentage = parseFloat(((_class.numberOfQuestionsCompleted / _class.numberOfQuestions) * 100).toFixed(2))

  return (
    <Link
      className="course"
      to={`/subjects/${_class.subjectId}`}
    >
      <div
        className="course-bg-image"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      ></div>
      <div className="course-title-wrapper">
        <span>{_class.className}</span>
        <span id="module-count">
          {_class.modulesCount} module{_class.modulesCount === 1 ? "" : "s"}
        </span>
      </div>
      {/* <div className="course-metadata-wrapper">
        <span>Subject: {_class.subjectName}</span>
        <span>{_class.numberOfQuestions} questions</span>
      </div> */}

      <div className="progress-bar-wrapper">
        <div className="progress-title-wrapper">
          <span>Progress</span>
          <span>{_class.numberOfQuestionsCompleted} / {_class.numberOfQuestions} questions ({completedPercentage}%)</span>
        </div>
        <ProgressBar
          completed={completedPercentage}
          bgColor="#316AFF"
          height="6px"
          isLabelVisible={false}
        />
      </div>
    </Link>
  );
};

export default CourseCard;
